/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Route from '@ember/routing/route';

export default class AudienceRoute extends Route {}
